import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Table} from 'antd'
import {transactions as columns} from './columns'

import style from './style.sass'

@inject('store') @observer
class Transactions extends Component {
  componentDidMount() {
    this.props.store.paperTrading.tables.transactions.load(this.props.id)
  }
  changePage = (page) => {
    this.props.store.paperTrading.tables.transactions.load(this.props.id, page.current)
  }
  render() {
    const {algo, tables} = this.props.store.paperTrading
    if (!algo) {
      return null
    }
    const {frequency} = algo
    const isIntraday = frequency === 'hourly' || frequency === 'minutely' || frequency === 'secondly'
    const {pagination: {size, count, page}, table, loading} = tables.transactions
    return(
      <div className='card' styleName='wrapper'>
        <Table
          onChange={this.changePage}
          dataSource={table}
          columns={columns(isIntraday)}
          loading={loading}
          size='small'
          pagination={{
            pageSize: size,
            total: count,
            current: page
          }}
          locale={loading ? {
            emptyText: 'Loading'
          } : {
            emptyText: 'No Data'
          }}
        />
      </div>
    )
  }
}

export default Transactions
